<template>
  <nav aria-label="Page navigation">
    <ul class="pagination justify-content-center">
      <li class="page-item" :class="{ disabled: currentPage === 1 }">
        <a class="page-link d-flex align-items-center justify-content-center" href="#" aria-label="Previous" @click.prevent="previousPage()">
          <span aria-hidden="true"><img src="https://spacebar.mints.cloud/public-assets/next" alt="" class="prev-icon"></span>
        </a>
      </li>
      <li class="page-item" v-for="pageNumber in pagesToShow()" :key="pageNumber"
          :class="{ active: currentPage === pageNumber }">
        <a class="page-link" href="#" @click.prevent="goToPage(pageNumber)">{{ pageNumber }}</a>
      </li>
      <li class="page-item" :class="{ disabled: currentPage === totalPages }">
        <a class="page-link page-link d-flex align-items-center justify-content-center" href="#" aria-label="Next" @click.prevent="nextPage()">
          <span aria-hidden="true"><img src="https://spacebar.mints.cloud/public-assets/next" alt="" class="next-icon"></span>
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    totalBlogItems: {
      type: Number,
      required: true
    },
    pageSize: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    },
    maxPageToShow: {
      type: Number,
      default: 5
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalBlogItems / this.pageSize);
    },
    maxVisibleButtons() {
      return Math.min(this.maxPageToShow, this.totalBlogItems);
    }
  },
  methods: {
    pagesToShow() {
      const pages = [];
      let startPage, endPage;

      if (this.totalPages <= this.maxVisibleButtons) {
        // Si hay pocas páginas, mostramos todas.
        startPage = 1;
        endPage = this.totalPages;
      } else {
        // Si hay muchas páginas, mostramos un rango.
        const halfPagesToShow = Math.floor(this.maxVisibleButtons / 2);
        startPage = Math.max(this.currentPage - halfPagesToShow, 1);
        endPage = startPage + this.maxVisibleButtons - 1;

        // Si el rango se sale de los límites, lo ajustamos.
        if (endPage > this.totalPages) {
          endPage = this.totalPages;
          startPage = endPage - this.maxVisibleButtons + 1;
        }
      }

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }

      return pages;
    },
    previousPage() {
      if (this.currentPage > 1) {
        this.$emit('page-change', this.currentPage - 1);
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.$emit('page-change', this.currentPage + 1);
      }
    },
    goToPage(pageNumber) {
      if (pageNumber >= 1 && pageNumber <= this.totalPages) {
        this.$emit('page-change', pageNumber);
      }
    }
  }
};
</script>

<style>
.next-icon{
  width: 15px;
  object-fit: cover;
  height: 15px;
}
.prev-icon{
  width: 15px;
  object-fit: cover;
  height: 15px;
  -moz-transform: scale(-1, 1);
  -webkit-transform: scale(-1, 1);
  -o-transform: scale(-1, 1);
  -ms-transform: scale(-1, 1);
  transform: scale(-1, 1);
  background-size: contain;
}
</style>